var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsisBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 431,
    viewBox: "0 0 1512 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1504,
    cy: 36,
    r: 17,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 398.5,
    r: 12.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 39.5,
    r: 19.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1466,
    cy: 375,
    r: 10,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 247.5,
    r: 12.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.5,
    cy: 17.5,
    r: 12.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 991.5,
    cy: 413.5,
    r: 12.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 591.5,
    cy: 418.5,
    r: 5.5,
    fill: "#391C99"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1311.5,
    cy: 342.5,
    r: 5.5,
    fill: "#391C99"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.5,
    cy: 47.5,
    r: 8.5,
    fill: "#391C99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisBg);
export default __webpack_public_path__ + "static/media/EllipsisBg.cfe1bcabcc567333e91a3cca1f3df38a.svg";
export { ForwardRef as ReactComponent };